import {ConstantsService} from "../ConstantsService";
import {VendasPedidoService} from "../../services/vendas-pedido.service";
import {PedidosService} from "../../services/pedidos.service";
import {GridPedidosComponent} from "../../pedidos/grid-pedidos/grid-pedidos.component";
import {CuponsService} from "../../superadmin/services/cupons.service";
import {ImpressaoService} from "../../services/impressao.service";
import {Component, OnInit, ViewChild} from "@angular/core";

import {ActivatedRoute, Router} from "@angular/router";
import {AutorizacaoService} from "../../services/autorizacao.service";
import {
  aggregateBy,
  AggregateDescriptor,
  AggregateResult, GroupDescriptor,
  orderBy,
  process,
  SortDescriptor
} from "@progress/kendo-data-query";
import {ExcelExportData, toDataURL} from "@progress/kendo-angular-excel-export";
import {RedesService} from "../../services/redes.service";
import {ProcessadorReciboTexto} from "../../services/impressao/ProcessadorReciboTexto";
import {PromocoesService} from "../../compartilhado/services/promocoes.service";
import {SelectEvent} from "@progress/kendo-angular-layout";
import {EmpresasService} from "../../superadmin/services/empresas.service";

declare var moment;
@Component({
  selector: 'app-financeiro-delivery',
  templateUrl: './financeiro-delivery.component.html',
  styleUrls: ['./financeiro-delivery.component.scss', '../financeiro/financeiro.component.scss']
})
export class FinanceiroDeliveryComponent implements OnInit {
  @ViewChild('gridPedidos', { static: false}) gridPedidos: GridPedidosComponent;
  filtro: any = {pagos: true, naoPagos: false, delivery: true, mesa: false, baseData: 'venda'};
  filtroRascunho: any = {};
  periodoRapido = 'hoje';
  filtrosAvancadosAbertos = false;
  visualizacaoVendas: 'tabela' | 'grafico' = 'tabela';
  ultimaAtualizacao: Date;
  erroCarregamento = '';
  exportandoRelatorio = false;
  sequenciaResumo = 0;
  abaPrincipalAtiva: 'loja' | 'vendas' | 'produtos' | 'vendemJuntos' | 'combinacoesProdutos' | 'cupons' | 'promocoes' | 'formas' | 'formasEntrega' | 'garcons' | 'operadores' = 'vendas';

  empresa: any = {};
  resumoVendas = {
    empresa: this.empresa,
    baseData: 'venda',
    dataInicial: this.filtro.inicio,
    dataFinal: this.filtro.fim,
    total: 0,
    totalComTaxa: 0,
    totalPagamentosComTaxa: 0,
    filtradoPorFormaPagamento: false,
    taxaDeEntrega: 0,
    totalTaxaFormaPagamento: 0,
    qtde: 0,
    qtdeLinhas: 0,
    ticketMedio: 0,
    formasDePagamento:  [],
    formasDeEntrega:  [],
    cupons:  [],
    lojas:  [],
    diarias: [],
    promocoes: []
  }
  resumoProdutos: any = {
    produtos: [],
    carregando: false,
    totalDescontos: 0
  }
  resumoCupons: any = {
    cupons: [],
    carregando: false
  }

  resumoPromocoes: any = {
    promocoes: [],
    carregando: false
  }
  resumoCombinacoes: any = {
    qtdeTotal: 0,
    totalAdicionais: 0,
    combinacoes: [],
    carregando: false
  }
  resumoProdutosQueVendemJuntos: any = {
    pedidosAnalisados: 0,
    paresEncontrados: 0,
    principalOportunidade: null,
    pares: [],
    carregando: false,
    carregado: false
  }
  minimoPedidosJuntos = 3;
  produtoBaseVendemJuntos: any = null;
  parVendemJuntosSelecionado: any = null;
  buscaProdutoVendemJuntos = '';
  buscaProdutoVendemJuntosRascunho = '';
  ordenacaoVendemJuntos = 'pedidosJuntos';
  ordenacoesVendemJuntos = [
    {valor: 'pedidosJuntos', nome: 'Mais pedidos juntos'},
    {valor: 'taxaJunto', nome: 'Maior adesão histórica'},
    {valor: 'forca', nome: 'Maior força'}
  ];
  erroProdutosQueVendemJuntos = '';
  pedidosParVendemJuntos: any[] = [];
  carregandoPedidosParVendemJuntos = false;
  exibindoPedidosParVendemJuntos = false;
  direcaoInversaVendemJuntosAberta = '';
  Math = Math;
  hoje: Date = new Date();
  dataAtual = null;
  valorMes: Date;
  carregando: boolean;
  vendasDoDia: any;
  vendasProduto: any;
  vendasProdutoAbaAtiva: 'adicionais' | 'combinacoes' = 'adicionais';
  resumoCombinacoesProduto: any = { qtdeTotal: 0, totalAdicionais: 0, combinacoes: [] };
  carregandoAdicionaisProduto = false;
  carregandoCombinacoesProduto = false;
  combinacoesProdutoCarregadas = false;
  cupons = []
  garcons = [];
  operadores = [];
  promocoes = []

  configImpressao: any;
  rede = false;
  usuario: any = null;
  carregandoResumoFormaPagamento: boolean
  resumoPorFormasPagamento: any = []
  sortCupom:  SortDescriptor[] = [{dir: 'desc', field: 'qtde'}  ];
  sortLoja:  SortDescriptor[] = [{dir: 'desc', field: 'qtde'}  ];
  vendasCuponsResultSet: any
  vendasPromocoesResultSet: any
  vendasLojasResultSet: any
  redes: any = [];
  periodoEspecifico: boolean;

  resumoGarcons: any = {
    garcons: [],
    carregando: false
  }

  resumoOperadores: any = {
    operadores: [],
    carregando: false
  }

  public aggregates: AggregateDescriptor[] = [
    { field: "qtde", aggregate: "sum" },
    { field: "total", aggregate: "sum" },
    { field: "totalDesconto", aggregate: "sum" },
  ];

  groupable: any = { showFooter: true };
  public group: GroupDescriptor[] = [
    { field: "Produtos", aggregates: this.aggregates },
  ];

  totalCupons: AggregateResult;
  timeoutCarregandoResumo: NodeJS.Timer;
  sortPromocoes: SortDescriptor[] =  [{dir: 'desc', field: 'qtde'}  ];
  totalPromocoes: AggregateResult;

  balcao = false;
  constructor(private router: Router, private constantsService: ConstantsService,
              private vendasService: VendasPedidoService, private pedidosService: PedidosService,
              private  cuponsService: CuponsService, private impressaoService: ImpressaoService,
              private promocoesService: PromocoesService,  private empresaService: EmpresasService,
              private autorizacaoService: AutorizacaoService, private redesService: RedesService) {

    this.rede = this.router.url.indexOf('/admin-rede') >= 0;

    if( this.router.url.indexOf('/financeiro-balcao') >= 0)
      this.balcao  = true;

    this.constantsService.empresa$.subscribe( (empresa: any) => {

      if(empresa) {
        this.empresa = empresa
        this.configImpressao = this.empresa.configImpressao;
      }
    });

    this.usuario = this.autorizacaoService.getUser();


    if(this.rede )
      this.redes = this.redesService.redesEmpresa();


    this.periodoEspecifico = true;

  }

  ngOnInit(): void {

    if(this.balcao) {
      this.filtro.delivery = false;
      this.filtro.balcao = true;
    }
    this.filtro.inicio = moment().startOf('days').toDate();
    this.filtro.fim = moment().endOf('days').toDate();
    this.filtroRascunho = this.copieFiltro(this.filtro);
    this.abaPrincipalAtiva = this.rede ? 'loja' : 'vendas';
    this.carregueResumoVendas();


  }

  async carregueResumoFormas() {
    return new Promise((resolve, reject) => {
      if(!this.resumoPorFormasPagamento.length)  {
        this.carregandoResumoFormaPagamento = true;

        let filtro: any = this.obtenhaFiltro();

        filtro.agfp = true;

        this.vendasService.obtenhaResumo(filtro).then( (resposta) => {
          this.resumoPorFormasPagamento = resposta.formasDePagamento || [];
          this.resumoVendas.formasDePagamento =  this.resumoPorFormasPagamento;
          this.carregandoResumoFormaPagamento = false;
          resolve('');
        }).catch((erro) => {
          this.carregandoResumoFormaPagamento = false;
          alert(erro); reject()
        })
      } else {
        resolve('');
      }
    });
  }

  public mudouValorMes(mes: Date) {
    this.filtro.inicio = moment(mes).startOf('month').toDate();
    this.filtro.fim = moment(mes).endOf('month').toDate();

    this.carregueResumoVendas();
  }

  public carregueResumoVendas(imediato = false) {
    if(this.carregando)
      clearTimeout(this.timeoutCarregandoResumo)

    this.carregando = true;
    const sequencia = ++this.sequenciaResumo;

    this.erroCarregamento = '';
    this.timeoutCarregandoResumo = setTimeout(() => {
      this.vendasService.obtenhaResumo(this.obtenhaFiltro()).then( (resposta) => {
        if(sequencia !== this.sequenciaResumo) return;
        this.carregando = false;
        this.resumoVendas = resposta;
        this.resumoVendas.baseData = this.filtro.baseData;
        this.ultimaAtualizacao = new Date();
        this.resumoProdutos = { produtos: [], totalDescontos: 0 };
        this.resumoCombinacoes = { qtdeTotal: 0, totalAdicionais: 0, combinacoes: [], carregando: false };
        this.resumoProdutosQueVendemJuntos = {
          pedidosAnalisados: 0, paresEncontrados: 0, principalOportunidade: null,
          pares: [], carregando: false, carregado: false
        };
        this.produtoBaseVendemJuntos = null;
        this.parVendemJuntosSelecionado = null;
        this.resumoPorFormasPagamento =  [];
        this.resumoGarcons = { garcons: [], carregando: false };
        this.resumoOperadores = { operadores: [], carregando: false };
        delete this.vendasDoDia;
        delete this.vendasProduto;
        this.vendasCuponsResultSet = orderBy(process(this.resumoVendas.cupons, {}).data, this.sortCupom);
        this.vendasPromocoesResultSet = orderBy(process(this.resumoVendas.promocoes, {}).data, this.sortPromocoes);
        this.totalCupons = aggregateBy(this.resumoVendas.cupons, this.aggregates);
        this.totalPromocoes = aggregateBy(this.resumoVendas.promocoes, this.aggregates);

        if(this.resumoVendas.lojas)
          this.vendasLojasResultSet = orderBy(process(this.resumoVendas.lojas, {}).data, this.sortLoja);

        this.cuponsService.listeCupons( {}).then( (cupons => {
          this.cupons = cupons || [];
        }))

        this.promocoesService.listePromocoes({}).then((promocoes => {
          this.promocoes = promocoes || [];
        }))


        setTimeout( () => {
          if(this.abaPrincipalAtiva === 'produtos')
            this.carregueResumoProdutos()
          else if(this.abaPrincipalAtiva === 'vendemJuntos')
            this.carregueResumoProdutosQueVendemJuntos();
          else if(this.abaPrincipalAtiva === 'combinacoesProdutos')
            this.carregueResumoCombinacoes();
          else if(this.abaPrincipalAtiva === 'operadores')
            this.carregueResumoOperadores();

          this.empresaService.listeGarcons(this.empresa).then((res: any) => {
            this.garcons = res.data;
          })

          this.empresaService.listeUsuarios(this.empresa).then((res: any) => {
            this.operadores = (res || []);
          })
        }, 0)
      }).catch((erro) => {
        if(sequencia !== this.sequenciaResumo) return;
        this.carregando = false;
        this.erroCarregamento = typeof erro === 'string' ? erro : 'Não foi possível carregar o relatório financeiro.';
      })
      }, imediato ? 0 : 1000)
  }

  selecionePeriodoRapido(periodo: string) {
    const hoje = moment().startOf('day');
    this.periodoRapido = periodo;

    if(periodo === 'hoje') {
      this.filtroRascunho.inicio = hoje.toDate();
      this.filtroRascunho.fim = moment(hoje).endOf('day').toDate();
    } else if(periodo === 'ontem') {
      this.filtroRascunho.inicio = moment(hoje).subtract(1, 'day').toDate();
      this.filtroRascunho.fim = moment(hoje).subtract(1, 'day').endOf('day').toDate();
    } else if(periodo === '7dias') {
      this.filtroRascunho.inicio = moment(hoje).subtract(6, 'days').toDate();
      this.filtroRascunho.fim = moment(hoje).endOf('day').toDate();
    } else if(periodo === 'mes') {
      this.filtroRascunho.inicio = moment(hoje).startOf('month').toDate();
      this.filtroRascunho.fim = moment(hoje).endOf('day').toDate();
    }
  }

  marquePeriodoPersonalizado() {
    this.periodoRapido = 'personalizado';
  }

  altereBaseData(baseData: 'venda' | 'pagamento') {
    this.filtroRascunho.baseData = baseData;
    if(baseData === 'pagamento') {
      this.filtroRascunho.pagos = true;
      this.filtroRascunho.naoPagos = false;
    }

    // A base do período é aplicada imediatamente sem carregar junto outras
    // alterações que ainda estejam pendentes no formulário de filtros.
    this.filtro.baseData = baseData;
    if(baseData === 'pagamento') {
      this.filtro.pagos = true;
      this.filtro.naoPagos = false;
    }
    this.carregueResumoVendas(true);
  }

  apliqueFiltros() {
    if(!this.filtroRascunho.inicio || !this.filtroRascunho.fim) return;

    if(moment(this.filtroRascunho.fim).isBefore(moment(this.filtroRascunho.inicio))) {
      this.erroCarregamento = 'A data e o horário final devem ser iguais ou posteriores ao início.';
      return;
    }

    if(this.filtroRascunho.baseData === 'pagamento') {
      this.filtroRascunho.pagos = true;
      this.filtroRascunho.naoPagos = false;
    }
    this.filtro = this.copieFiltro(this.filtroRascunho);
    this.carregueResumoVendas(true);
  }

  limpeFiltros() {
    const canaisPadrao = this.balcao
      ? {delivery: false, mesa: false, balcao: true}
      : {delivery: true, mesa: false, balcao: false};
    this.filtroRascunho = {
      inicio: moment().startOf('day').toDate(),
      fim: moment().endOf('day').toDate(),
      pagos: true,
      naoPagos: false,
      baseData: 'venda',
      ...canaisPadrao
    };
    this.periodoRapido = 'hoje';
    this.apliqueFiltros();
  }

  get quantidadeFiltrosAtivos() {
    let total = 1;
    if(this.filtroRascunho.pagos || this.filtroRascunho.naoPagos) total++;
    if(this.filtroRascunho.delivery || this.filtroRascunho.mesa || this.filtroRascunho.balcao) total++;
    ['rede', 'formasDePagamento', 'formaDeEntregaEmpresa', 'cupons', 'promocoes', 'operadores', 'garcons']
      .forEach((campo: string) => {
        const valor = this.filtroRascunho[campo];
        if(Array.isArray(valor) ? valor.length : !!valor) total++;
      });
    return total;
  }

  get rotuloBaseData() {
    return this.filtro.baseData === 'pagamento' ? 'Pagamento (quitação)' : 'Venda/entrega';
  }

  get filtrandoPorFormaPagamento() {
    return !!(this.filtro.formasDePagamento && this.filtro.formasDePagamento.length);
  }

  get totalFinanceiroExibido() {
    return this.filtrandoPorFormaPagamento ?
      Number(this.resumoVendas.totalPagamentosComTaxa || 0) : Number(this.resumoVendas.totalComTaxa || 0);
  }

  get rotuloTotalFinanceiro() {
    return this.filtrandoPorFormaPagamento ? 'Total em pagamentos' : 'Total de vendas';
  }

  get descricaoTotalFinanceiro() {
    return this.filtrandoPorFormaPagamento ? 'Valor recebido nas formas selecionadas' : this.rotuloBaseData;
  }

  get campoTotalFinanceiroDiario() {
    return this.filtrandoPorFormaPagamento ? 'totalPagamentosComTaxa' : 'totalComTaxa';
  }

  get rotuloColunaData() {
    return this.filtro.baseData === 'pagamento' ? 'Data da quitação' : 'Data da venda/entrega';
  }

  get percentualTaxaEntrega() {
    return this.calculePercentual(this.resumoVendas.taxaDeEntrega, this.resumoVendas.totalComTaxa);
  }

  get percentualTaxaPagamento() {
    return this.calculePercentual(this.resumoVendas.totalTaxaFormaPagamento, this.resumoVendas.totalComTaxa);
  }

  private calculePercentual(valor: any, total: any) {
    return Number(total) > 0 ? Number(valor || 0) * 100 / Number(total) : 0;
  }

  private copieFiltro(filtro: any) {
    const copia = {...filtro};
    ['formasDePagamento', 'cupons', 'promocoes', 'operadores', 'garcons'].forEach((campo: string) => {
      if(Array.isArray(filtro[campo])) copia[campo] = filtro[campo].slice();
    });
    return copia;
  }

  private carregueResumoGarcons() {
    this.resumoGarcons.carregando = true;

    this.vendasService.obtenhaResumoGarconsVendas(this.obtenhaFiltro()).then((resposta) => {
      this.resumoGarcons.carregando = false;
      this.resumoGarcons = resposta;
    }).catch((erro) => {
      this.resumoGarcons.carregando = false;
      alert(erro);
    })
  }

  private carregueResumoOperadores() {
    this.resumoOperadores.carregando = true;

    this.vendasService.obtenhaResumoOperadoresVendas(this.obtenhaFiltro()).then((resposta) => {
      this.resumoOperadores.carregando = false;
      this.resumoOperadores = resposta;
    }).catch((erro) => {
      this.resumoOperadores.carregando = false;
      alert(erro);
    })
  }

  public carregueResumoProdutos() {

   if(!this.filtro.porAdicionais){
     this.group[0].field = 'Produtos'
     this.resumoProdutos.carregando = true;
     this.vendasService.obtenhaResumoPrudutos(this.obtenhaFiltro()).then( (resposta) => {
       this.resumoProdutos.carregando = false;
       this.resumoProdutos = resposta;
     })
   }  else {
     this.group[0].field = 'Adicionais'
     this.resumoProdutos.carregando = true;
     this.vendasService.obtenhaResumoAdicionais(this.obtenhaFiltro()).then( (resposta) => {
       this.resumoProdutos.carregando = false;
       this.resumoProdutos = resposta;
       this.resumoProdutos.produtos = resposta.adicionais;
     })
   }
  }

  public carregueResumoCombinacoes() {
    if(this.resumoCombinacoes.carregando) return;
    if(this.resumoCombinacoes.combinacoes && this.resumoCombinacoes.combinacoes.length) return;

    this.resumoCombinacoes.carregando = true;

    this.vendasService.obtenhaResumoAdicionaisCombinacoes(this.obtenhaFiltro()).then((resposta: any) => {
      const combinacoes = (resposta?.combinacoes || []).slice();
      combinacoes.sort((a: any, b: any) => Number(b.qtde || 0) - Number(a.qtde || 0));

      this.resumoCombinacoes = {
        qtdeTotal: Number(resposta?.qtdeTotal || 0),
        totalAdicionais: Number(resposta?.totalAdicionais || 0),
        combinacoes: combinacoes,
        carregando: false
      };
    }).catch((erro) => {
      this.resumoCombinacoes.carregando = false;
      alert(erro);
    });
  }

  public carregueResumoProdutosQueVendemJuntos(force = false) {
    if(this.resumoProdutosQueVendemJuntos.carregando) return;
    if(this.resumoProdutosQueVendemJuntos.carregado && !force) return;

    this.resumoProdutosQueVendemJuntos.carregando = true;
    this.parVendemJuntosSelecionado = null;
    this.direcaoInversaVendemJuntosAberta = '';
    this.erroProdutosQueVendemJuntos = '';
    const filtro = {...this.obtenhaFiltro(), mpj: Math.max(1, Number(this.minimoPedidosJuntos || 3))};

    this.vendasService.obtenhaResumoProdutosQueVendemJuntos(filtro).then((resposta: any) => {
      this.resumoProdutosQueVendemJuntos = {
        pedidosAnalisados: Number(resposta?.pedidosAnalisados || 0),
        paresEncontrados: Number(resposta?.paresEncontrados || 0),
        principalOportunidade: resposta?.principalOportunidade || null,
        pares: resposta?.pares || [],
        carregando: false,
        carregado: true
      };
    }).catch((erro) => {
      this.resumoProdutosQueVendemJuntos.carregando = false;
      this.erroProdutosQueVendemJuntos = 'Não foi possível descobrir quais produtos vendem juntos. Tente novamente.';
    });
  }

  get produtosBaseVendemJuntos() {
    const produtos: any[] = [];
    (this.resumoProdutosQueVendemJuntos.pares || []).forEach((par: any) => {
      if(!produtos.some((produto: any) => produto.id === par.idProdutoBase))
        produtos.push({id: par.idProdutoBase, nome: par.produtoBase});
    });
    return produtos.sort((a: any, b: any) => a.nome.localeCompare(b.nome));
  }

  get paresVendemJuntosExibidos() {
    const todosPares = (this.resumoProdutosQueVendemJuntos.pares || []).slice();
    let pares: any[];

    if(this.produtoBaseVendemJuntos && this.produtoBaseVendemJuntos.id) {
      pares = todosPares
        .filter((par: any) => par.idProdutoBase === this.produtoBaseVendemJuntos.id)
        .map((par: any) => this.monteCombinacaoVendemJuntos(par, todosPares));
    } else {
      pares = this.agrupeCombinacoesVendemJuntos(todosPares);
    }

    const busca = this.normalizeTextoVendemJuntos(this.buscaProdutoVendemJuntos);
    if(busca)
      pares = pares.filter((par: any) =>
        this.normalizeTextoVendemJuntos(par.produtoBase).indexOf(busca) >= 0 ||
        this.normalizeTextoVendemJuntos(par.produtoJunto).indexOf(busca) >= 0);

    return pares.sort((a: any, b: any) => {
      const diferenca = Number(b[this.ordenacaoVendemJuntos] || 0) - Number(a[this.ordenacaoVendemJuntos] || 0);
      if(diferenca) return diferenca;
      return String(a.produtoBase || '').localeCompare(String(b.produtoBase || '')) ||
        String(a.produtoJunto || '').localeCompare(String(b.produtoJunto || ''));
    });
  }

  selecioneParVendemJuntos(par: any) {
    this.parVendemJuntosSelecionado = par;
    this.pedidosParVendemJuntos = [];
    this.exibindoPedidosParVendemJuntos = false;
  }

  volteParaListaVendemJuntos() {
    this.parVendemJuntosSelecionado = null;
    this.pedidosParVendemJuntos = [];
    this.exibindoPedidosParVendemJuntos = false;
  }

  alterneDirecaoInversaVendemJuntos(par: any) {
    this.direcaoInversaVendemJuntosAberta =
      this.direcaoInversaVendemJuntosAberta === par.chaveCombinacao ? '' : par.chaveCombinacao;
  }

  vireComboVendemJuntos(par: any) {
    this.router.navigate(['/admin/produtos-v2'], {queryParams: {
      produtoDrawer: par.idProdutoBase,
      drawerSurface: 'group-detail',
      drawerGroupMode: 'create',
      crossSellProdutoId: par.idProdutoJunto,
      origem: 'combinacoes-que-vendem'
    }});
  }

  carreguePedidosParVendemJuntos() {
    const par = this.parVendemJuntosSelecionado;
    if(!par || this.carregandoPedidosParVendemJuntos) return;
    if(this.pedidosParVendemJuntos.length) {
      this.exibindoPedidosParVendemJuntos = !this.exibindoPedidosParVendemJuntos;
      return;
    }

    this.carregandoPedidosParVendemJuntos = true;
    this.vendasService.obtenhaPedidosProdutosQueVendemJuntos({
      ...this.obtenhaFiltro(), pb: par.idProdutoBase, pj: par.idProdutoJunto
    }).then((pedidos: any) => {
      this.pedidosParVendemJuntos = pedidos || [];
      this.exibindoPedidosParVendemJuntos = true;
      this.carregandoPedidosParVendemJuntos = false;
    }).catch(() => {
      this.carregandoPedidosParVendemJuntos = false;
      this.erroProdutosQueVendemJuntos = 'Não foi possível carregar os pedidos desta combinação.';
    });
  }

  apliqueBuscaVendemJuntos() {
    this.buscaProdutoVendemJuntos = String(this.buscaProdutoVendemJuntosRascunho || '').trim();
  }

  get resumoProdutoBaseVendemJuntos() {
    if(!this.produtoBaseVendemJuntos || !this.produtoBaseVendemJuntos.id) return null;
    return (this.resumoProdutosQueVendemJuntos.pares || [])
      .find((par: any) => par.idProdutoBase === this.produtoBaseVendemJuntos.id) || null;
  }

  get principalOportunidadeVendemJuntos() {
    return this.paresVendemJuntosExibidos[0] || null;
  }

  get totalCombinacoesUnicasVendemJuntos() {
    return this.agrupeCombinacoesVendemJuntos(this.resumoProdutosQueVendemJuntos.pares || []).length;
  }

  get paresVendemJuntosParaCsv() {
    const pares = this.parVendemJuntosSelecionado ? [this.parVendemJuntosSelecionado] : this.paresVendemJuntosExibidos;
    return pares.map((par: any) => ({
      ...par,
      dataInicial: moment(this.filtro.inicio).format('DD/MM/YYYY HH:mm'),
      dataFinal: moment(this.filtro.fim).format('DD/MM/YYYY HH:mm')
    }));
  }

  private normalizeTextoVendemJuntos(valor: any) {
    return String(valor || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  private agrupeCombinacoesVendemJuntos(pares: any[]) {
    const combinacoes: {[chave: string]: any[]} = {};
    pares.forEach((par: any) => {
      const chave = this.obtenhaChaveCombinacaoVendemJuntos(par);
      combinacoes[chave] = combinacoes[chave] || [];
      combinacoes[chave].push(par);
    });

    return Object.keys(combinacoes).map((chave: string) => {
      const direcoes = combinacoes[chave].slice().sort((a: any, b: any) =>
        Number(b.pedidosProdutoBase || 0) - Number(a.pedidosProdutoBase || 0) ||
        Number(b.taxaJunto || 0) - Number(a.taxaJunto || 0) ||
        String(a.produtoBase || '').localeCompare(String(b.produtoBase || '')));
      return this.monteCombinacaoVendemJuntos(direcoes[0], pares);
    });
  }

  private monteCombinacaoVendemJuntos(direcaoRecomendada: any, todosPares: any[]) {
    const direcaoInversa = todosPares.find((par: any) =>
      par.idProdutoBase === direcaoRecomendada.idProdutoJunto &&
      par.idProdutoJunto === direcaoRecomendada.idProdutoBase) || null;
    return {
      ...direcaoRecomendada,
      chaveCombinacao: this.obtenhaChaveCombinacaoVendemJuntos(direcaoRecomendada),
      direcaoInversa
    };
  }

  private obtenhaChaveCombinacaoVendemJuntos(par: any) {
    return [String(par.idProdutoBase), String(par.idProdutoJunto)].sort().join(':');
  }


  obtenhaFiltro( ){
    let dados: any = {   }

    if(this.balcao) dados.bal  = true;
    else dados.delivery  =  true


    let dtInicio = this.filtro.inicio ?  moment(this.filtro.inicio).format('YYYYMMDD HH:mm:ss') : null;
    let dtFim = this.filtro.fim ? moment(this.filtro.fim).format('YYYYMMDD HH:mm:ss') : null;

    let formaDePagamento = this.filtro.formasDePagamento && this.filtro.formasDePagamento.length > 0 ?
      this.filtro.formasDePagamento.map( forma => forma.id).join(',') : null;

    let cupons = this.filtro.cupons && this.filtro.cupons.length > 0 ?
      this.filtro.cupons.map( cupon => this.rede ? cupon.codigo : cupon.id).join(',') : null;

    let promocoes = this.filtro.promocoes && this.filtro.promocoes.length > 0 ?
      this.filtro.promocoes.map( promocao => promocao.id).join(',') : null;

    let operadores = this.filtro.operadores && this.filtro.operadores.length > 0 ?
      this.filtro.operadores.map( operador => operador.id).join(',') : null;


    if(dtInicio) dados.di = dtInicio;
    if(dtFim) dados.df = dtFim;
    dados.bd = this.filtro.baseData === 'pagamento' ? 'pagamento' : 'venda';
    if(this.rede)   dados.r = 1;
    if(this.filtro.rede) dados.rid = this.filtro.rede.id;

    if(formaDePagamento) dados.fp = formaDePagamento;
    if(cupons){
      if(this.rede)
        dados.ccps = cupons;
      else
        dados.cps = cupons;
    }

    if(promocoes)
      dados.prs = promocoes;

    if(operadores)
      dados.ops = operadores;

    if(this.filtro.formaDeEntregaEmpresa) dados.fe = this.filtro.formaDeEntregaEmpresa.formaDeEntrega.id;

    let garcons = this.filtro.garcons && this.filtro.garcons.length > 0 ?
      this.filtro.garcons.map( garcom => garcom.id).join(',') : null;

    if(garcons) dados.gs = garcons;

    if(this.filtro.pagos) dados.pg = 1;
    if(this.filtro.naoPagos) dados.np = 1;
    if(this.filtro.mesa) dados.ms = 1;
    if(this.filtro.balcao) dados.bl = 1;
    if(this.filtro.delivery) dados.dl = 1;

    console.log("filtro calculado", dados)

    return dados;
  }

  verPedidos(resumoDia: any) {
    this.vendasDoDia = resumoDia;
    if(this.vendasDoDia.pedidos && this.vendasDoDia.pedidos.length) return;

    this.vendasDoDia.carregando = true;

    let dia = moment(this.vendasDoDia.dia, 'DD/MM/YYYY').format('YYYYMMDD')
    let formaDeEntrega = this.filtro.formaDeEntregaEmpresa ? this.filtro.formaDeEntregaEmpresa.formaDeEntrega : null;
    let formasDePagamento = this.filtro.formasDePagamento && this.filtro.formasDePagamento.length > 0 ?
      this.filtro.formasDePagamento.map( forma => forma.id)  : null;

    let cupons = this.filtro.cupons && this.filtro.cupons.length > 0 ?
      this.filtro.cupons.map( cupon => cupon.id) : null;

    let promocoes = this.filtro.promocoes && this.filtro.promocoes.length > 0 ?
      this.filtro.promocoes.map( promocao => promocao.id) : null;

    let operadores = this.filtro.operadores && this.filtro.operadores.length > 0 ?
      this.filtro.operadores.map( operador => operador.id) : null;

    let params: any = {
      dtInicio: dia, dtFim: dia,
      baseData: this.filtro.baseData,
      destino: 'delivery',
      formaDeEntrega: formaDeEntrega,
      formasDePagamento: formasDePagamento,
      cupons: cupons,
      promocoes: promocoes,
      operadores: operadores
    };

    if(this.filtro.mesa){
      if(this.filtro.delivery)
        delete params.destino
      else params.destino = 'mesas'
    } else if(this.filtro.balcao){
      if(this.filtro.delivery)
        delete params.destino
      else params.destino = 'balcao'
    }

    if( this.rede ) {
      params.r = 1;
    }

    if(this.filtro.pagos && this.filtro.naoPagos ) {
      params.pagosENaoPagos = true
    } else if(this.filtro.pagos){
      params.apenasPagos  = true
    } else if(this.filtro.naoPagos){
      params.naoPagos  = true
    }

    this.pedidosService.listePedidos(0, 10000, params).then( (resposta) => {
      this.vendasDoDia.pedidos = resposta ? (resposta.pedidos || []) : [];
      this.vendasDoDia.carregando = false;

      this.gridPedidos.atualizeGridPedidos(this.vendasDoDia.pedidos, String(`dia ${dia}`));
    }).catch( () => {
      this.vendasDoDia.carregando = false;
    });

  }

  verDetalhesVendasProduto(resumoProduto: any) {
    this.vendasProduto = resumoProduto;
    this.vendasProdutoAbaAtiva = 'adicionais';
    this.resumoCombinacoesProduto = { qtdeTotal: 0, totalAdicionais: 0, combinacoes: [] };
    this.carregandoAdicionaisProduto = false;
    this.combinacoesProdutoCarregadas = false;
    this.carregandoCombinacoesProduto = false;

    if(!this.vendasProduto.adicionais){
      this.carregandoAdicionaisProduto = true;
      this.vendasService.obtenhaResumoAdicionaisPruduto(this.vendasProduto.id, this.obtenhaFiltro()).then( (resposta) => {
         this.vendasProduto.adicionais = resposta?.adicionais || [];
         this.carregandoAdicionaisProduto = false;
      }).catch((erro) => {
        this.carregandoAdicionaisProduto = false;
        alert(erro);
      });
    }
  }

  selecionouTabDetalheProduto($event: SelectEvent) {
    if($event.title.indexOf('Combinações') >= 0){
      this.vendasProdutoAbaAtiva = 'combinacoes';
      this.carregueResumoCombinacoesProduto();
      return;
    }

    this.vendasProdutoAbaAtiva = 'adicionais';
  }

  carregueResumoCombinacoesProduto() {
    if(!this.vendasProduto || this.carregandoCombinacoesProduto || this.combinacoesProdutoCarregadas)
      return;

    this.carregandoCombinacoesProduto = true;

    this.vendasService.obtenhaResumoAdicionaisCombinacoesProduto(this.vendasProduto.id, this.obtenhaFiltro()).then((resposta: any) => {
      this.carregandoCombinacoesProduto = false;
      this.combinacoesProdutoCarregadas = true;

      const combinacoes = (resposta?.combinacoes || []).slice();
      combinacoes.sort((a: any, b: any) => Number(b.qtde || 0) - Number(a.qtde || 0));

      this.resumoCombinacoesProduto = {
        qtdeTotal: Number(resposta?.qtdeTotal || 0),
        totalAdicionais: Number(resposta?.totalAdicionais || 0),
        combinacoes: combinacoes
      };
    }).catch((erro) => {
      this.carregandoCombinacoesProduto = false;
      alert(erro);
    });
  }


  async selecionouTab($event: SelectEvent) {
    this.atualizeAbaPrincipalAtiva($event);

    if($event.title.indexOf('Produtos') >= 0  && ( !this.resumoProdutos.produtos || !this.resumoProdutos.produtos.length))
      this.carregueResumoProdutos();

    if($event.title === 'Combinações que Vendem')
      this.carregueResumoProdutosQueVendemJuntos();

    if($event.title === 'Combinações' && (!this.resumoCombinacoes.combinacoes || !this.resumoCombinacoes.combinacoes.length))
      this.carregueResumoCombinacoes();

    if(($event.title.indexOf('Garçom') >= 0 || $event.title.indexOf('Garçons') >= 0) && (!this.resumoGarcons.garcons || !this.resumoGarcons.garcons.length))
      this.carregueResumoGarcons();

    if($event.title.indexOf('Operador') >= 0 && (!this.resumoOperadores.operadores || !this.resumoOperadores.operadores.length))
      this.carregueResumoOperadores();

    if($event.title.indexOf('Formas') >= 0 || $event.title.indexOf('Pagamentos') >= 0)
     await this.carregueResumoFormas();

  }

  private atualizeAbaPrincipalAtiva($event: SelectEvent) {
    const titulo = String($event.title || '').toLowerCase();

    if(titulo.indexOf('por loja') >= 0 || titulo === 'lojas') {
      this.abaPrincipalAtiva = 'loja';
      return;
    }

    if(titulo.indexOf('vendas diárias') >= 0 || titulo.indexOf('vendas diarias') >= 0) {
      this.abaPrincipalAtiva = 'vendas';
      return;
    }

    if(titulo.indexOf('por produtos') >= 0 || titulo === 'produtos') {
      this.abaPrincipalAtiva = 'produtos';
      return;
    }

    if(titulo === 'combinações que vendem' || titulo === 'combinacoes que vendem') {
      this.abaPrincipalAtiva = 'vendemJuntos';
      return;
    }

    if(titulo === 'combinações' || titulo === 'combinacoes') {
      this.abaPrincipalAtiva = 'combinacoesProdutos';
      return;
    }

    if(titulo.indexOf('por cupons') >= 0 || titulo === 'cupons') {
      this.abaPrincipalAtiva = 'cupons';
      return;
    }

    if(titulo.indexOf('por promoções') >= 0 || titulo.indexOf('por promocoes') >= 0 || titulo === 'promoções') {
      this.abaPrincipalAtiva = 'promocoes';
      return;
    }

    if(titulo.indexOf('formas de pagamento') >= 0 || titulo === 'pagamentos') {
      this.abaPrincipalAtiva = 'formas';
      return;
    }

    if(titulo.indexOf('formas entrega') >= 0 || titulo === 'entregas') {
      this.abaPrincipalAtiva = 'formasEntrega';
      return;
    }

    if(titulo.indexOf('garçom') >= 0 || titulo.indexOf('garcom') >= 0 || titulo.indexOf('garç') >= 0) {
      this.abaPrincipalAtiva = 'garcons';
      return;
    }

    if(titulo.indexOf('operador') >= 0) {
      this.abaPrincipalAtiva = 'operadores';
    }
  }

  voltarVendasDia() {
    delete this.vendasDoDia;
  }

  voltarVendasProdutos(){
    delete this.vendasProduto;
    this.vendasProdutoAbaAtiva = 'adicionais';
    this.resumoCombinacoesProduto = { qtdeTotal: 0, totalAdicionais: 0, combinacoes: [] };
    this.carregandoAdicionaisProduto = false;
    this.combinacoesProdutoCarregadas = false;
    this.carregandoCombinacoesProduto = false;
  }

  obtenhaDescricaoFiltro() {
    const inicio = moment(this.filtro.inicio);
    const fim = moment(this.filtro.fim);
    const periodoDiaCompleto = inicio.isSame(fim, 'day') &&
      inicio.format('HH:mm:ss') === '00:00:00' && fim.format('HH:mm:ss') === '23:59:59';

    if(periodoDiaCompleto)
      return String(` do dia ${inicio.format('DD/MM/YYYY')}`)

    return String(`entre ${inicio.format('DD/MM/YYYY HH:mm')} e ${fim.format('DD/MM/YYYY HH:mm')}`);
  }

  obtenhaNomeArquivo() {
    let sufixo = this.vendasProduto ? this.vendasProduto.nome.replace(/\s/g, '-') : '';
    return String(`produtos-adicionais-${sufixo}.xls`)
  }

  obtenhaNomeArquivoCombinacoes() {
    let sufixo = this.vendasProduto ? this.vendasProduto.nome.replace(/\s/g, '-') : '';
    return String(`produtos-adicionais-combinacoes-${sufixo}.xls`)
  }

  obtenhaNomeArquivoCombinacoesGeral() {
    return this.obtenhaNomeArquivoDownload('vendas-adicionais-combinacoes');
  }

  obtenhaNomeArquivoDownload(nome: string) {
    let sufixo = '', horario = new Date().getTime();

    let inicio =  moment(this.filtro.inicio).format('DD-MM-YYYY');
    let fim =  moment(this.filtro.fim).format('DD-MM-YYYY');

    if(this.filtro.rede)
      nome = String(`${nome}-${this.filtro.rede.nome.toLowerCase()}`)

    sufixo = String(`${inicio}_e_${fim}`)

    return String(`${nome}(${sufixo}).xls`)
  }

  imprimaRelatorio(impressora: any = null) {
    if(this.configImpressao && this.configImpressao.imprimirTXT)
      return this.imprimaNativamente(this.configImpressao.impressoras[0]);

    let link = '/imprimir/relatorio/delivery'

    let query = []

    if(this.filtro.inicio) query.push('inicio=' + moment(this.filtro.inicio).format('YYYYMMDD HH:mm:ss'))
    if(this.filtro.fim) query .push('fim=' + moment(this.filtro.fim).format('YYYYMMDD HH:mm:ss'))
    query.push('bd=' + (this.filtro.baseData === 'pagamento' ? 'pagamento' : 'venda'))

    let formaDePagamento = this.filtro.formasDePagamento && this.filtro.formasDePagamento.length > 0 ?
      this.filtro.formasDePagamento.map( forma => forma.id).join(',') : null;

    let cupons = this.filtro.cupons && this.filtro.cupons.length > 0 ?
      this.filtro.cupons.map( cupon => cupon.id).join(',') : null;

    let promocoes = this.filtro.promocoes && this.filtro.promocoes.length > 0 ?
      this.filtro.promocoes.map( promocao => promocao.id).join(',') : null;

    let operadores = this.filtro.operadores && this.filtro.operadores.length > 0 ?
      this.filtro.operadores.map( operador => operador.id).join(',') : null;

    if(formaDePagamento) query.push('fp=' + formaDePagamento);
    if(cupons) query.push('cps=' + cupons);
    if(promocoes) query.push('prs=' + promocoes);
    if(operadores) query.push('ops=' + operadores);
    if(this.filtro.formaDeEntregaEmpresa) query.push('fe=' + this.filtro.formaDeEntregaEmpresa.formaDeEntrega.id);
    if(this.filtro.naoPagos) query.push('np=1');

    if(this.filtro.delivery) query.push('dl=1');
    if(this.filtro.mesa) query.push('ms=1');
    if(this.filtro.balcao) query.push('bl=1');


    if(query.length > 0)
      link += '?' + query.join('&')

    window.open(link);
  }

  private async imprimaNativamente(impressora: any) {
    this.resumoVendas.dataInicial = this.filtro.inicio
    this.resumoVendas.dataFinal = this.filtro.fim
    this.resumoVendas.empresa = this.empresa
    this.resumoVendas.baseData = this.filtro.baseData
    this.resumoVendas.filtradoPorFormaPagamento = this.filtrandoPorFormaPagamento

    await this.carregueResumoFormas();

    if(!impressora) impressora = this.configImpressao.impressoras[0]

    console.log(this.resumoVendas)
    let relatorio: any = new ProcessadorReciboTexto(impressora).obtenhaRelatorio(this.resumoVendas)
    console.log(relatorio)
    this.impressaoService.imprimaTexto(relatorio, impressora)
  }

  downloadCsvProdutos() {
    let link = '/exportar/vendas/produtos/csv?';
    let filtro = this.obtenhaFiltro();

    Object.keys(filtro).forEach( key => {
      link  = String(`${link}${key}=${filtro[key]}&`) ;
    })

    window.open(link  );
  }

  async exporteRelatorioCompleto() {
    if(this.exportandoRelatorio || this.carregando) return;

    this.exportandoRelatorio = true;
    this.erroCarregamento = '';
    try {
      const filtro = this.obtenhaFiltro();
      const [produtos, produtosJuntos, combinacoes, formas, garcons, operadores]: any[] = await Promise.all([
        this.vendasService.obtenhaResumoPrudutos({...filtro}),
        this.vendasService.obtenhaResumoProdutosQueVendemJuntos({...filtro, mpj: this.minimoPedidosJuntos}),
        this.vendasService.obtenhaResumoAdicionaisCombinacoes({...filtro}),
        this.vendasService.obtenhaResumo({...filtro, agfp: true}),
        this.filtro.mesa ? this.vendasService.obtenhaResumoGarconsVendas({...filtro}) : Promise.resolve({garcons: []}),
        this.vendasService.obtenhaResumoOperadoresVendas({...filtro})
      ]);

      const sheets: any[] = [
        this.montePlanilhaRelatorio('Resumo', [
          ['Indicador', 'indicador'], ['Valor', 'valor', 'moeda']
        ], this.dadosResumoExcel()),
        this.montePlanilhaRelatorio('Vendas diárias', this.colunasVendasDiarias(), this.resumoVendas.diarias || []),
        this.montePlanilhaRelatorio('Produtos', [
          ['Código', 'codigo'], ['Produto', 'nome'], ['Quantidade', 'qtde'], ['Total', 'total', 'moeda']
        ], produtos?.produtos || []),
        this.montePlanilhaRelatorio('Combinações que Vendem', [
          ['Produto âncora', 'produtoBase'], ['Sugestão de cross-sell', 'produtoJunto'],
          ['Pedidos juntos', 'pedidosJuntos'], ['Adesão histórica (%)', 'taxaJunto'],
          ['Frequência geral (%)', 'frequenciaGeral'], ['Força', 'forca']
        ], this.agrupeCombinacoesVendemJuntos(produtosJuntos?.pares || [])),
        this.montePlanilhaRelatorio('Combinações', [
          ['Produto', 'produto'], ['Combinação', 'descricaoCombinacao'], ['Quantidade', 'qtde'], ['Total adicionais', 'totalAdicionais', 'moeda']
        ], combinacoes?.combinacoes || []),
        this.montePlanilhaRelatorio('Cupons', [
          ['Cupom', 'codigo'], ['Quantidade', 'qtde'], ['Total', 'total', 'moeda'], ['Descontos', 'totalDesconto', 'moeda']
        ], this.resumoVendas.cupons || []),
        this.montePlanilhaRelatorio('Promoções', [
          ['Promoção', 'descricao'], ['Quantidade', 'qtde'], ['Total', 'total', 'moeda'], ['Descontos', 'totalDesconto', 'moeda']
        ], this.resumoVendas.promocoes || []),
        this.montePlanilhaRelatorio('Pagamentos', [
          ['Forma de pagamento', 'nome'], ['Quantidade', 'qtde'], ['Total', 'total', 'moeda'], ['Taxas', 'totalTaxas', 'moeda']
        ], formas?.formasDePagamento || []),
        this.montePlanilhaRelatorio('Entregas', [
          ['Forma de entrega', 'nome'], ['Quantidade', 'qtde'], ['Total', 'total', 'moeda']
        ], this.resumoVendas.formasDeEntrega || []),
        this.montePlanilhaRelatorio('Operadores', [
          ['Operador', 'operador'], ['Pedidos', 'qtde'], ['Total', 'total', 'moeda']
        ], operadores?.operadores || [])
      ];

      if(this.rede) sheets.splice(2, 0, this.montePlanilhaRelatorio('Lojas', [
        ['Código', 'codigoLoja'], ['Loja', 'nomeLoja'], ['Pedidos', 'qtde'], ['Total', 'totalComTaxa', 'moeda']
      ], this.resumoVendas.lojas || []));
      if(this.filtro.mesa) sheets.push(this.montePlanilhaRelatorio('Garçons', [
        ['Garçom', 'garcom'], ['Pedidos', 'qtde'], ['Total', 'total', 'moeda']
      ], garcons?.garcons || []));

      const dataUrl = await toDataURL({creator: 'Promokit', date: new Date(), sheets});
      const link = document.createElement('a');
      link.href = dataUrl;
      link.download = `RELATORIO_FINANCEIRO_${this.filtro.baseData === 'pagamento' ? 'QUITACAO' : 'VENDA'}_${moment(this.filtro.inicio).format('YYYYMMDD')}_A_${moment(this.filtro.fim).format('YYYYMMDD')}.xlsx`;
      link.click();
    } catch(erro) {
      this.erroCarregamento = 'Não foi possível gerar o relatório completo.';
    } finally {
      this.exportandoRelatorio = false;
    }
  }

  exporteCsvAbaAtiva() {
    const configuracao: any = this.obtenhaConfiguracaoCsvAtiva();
    if(!configuracao) return;

    const escape = (valor: any) => `"${String(valor == null ? '' : valor).replace(/"/g, '""')}"`;
    const linhas = [configuracao.colunas.map((coluna: any) => escape(coluna[0])).join(';')];
    (configuracao.dados || []).forEach((item: any) => {
      linhas.push(configuracao.colunas.map((coluna: any) => escape(item[coluna[1]])).join(';'));
    });
    const url = URL.createObjectURL(new Blob(['\ufeff' + linhas.join('\r\n')], {type: 'text/csv;charset=utf-8'}));
    const link = document.createElement('a');
    link.href = url;
    link.download = `financeiro-${this.abaPrincipalAtiva}-${moment(this.filtro.inicio).format('YYYYMMDD')}.csv`;
    link.click();
    URL.revokeObjectURL(url);
  }

  private dadosResumoExcel() {
    if(this.filtrandoPorFormaPagamento) {
      return [
        {indicador: 'Total em pagamentos', valor: this.totalFinanceiroExibido},
        {indicador: 'Quantidade de pedidos', valor: this.resumoVendas.qtde}
      ];
    }

    return [
      {indicador: 'Total de vendas', valor: this.totalFinanceiroExibido},
      {indicador: 'Total de produtos', valor: this.resumoVendas.total},
      {indicador: 'Taxas de pagamento', valor: this.resumoVendas.totalTaxaFormaPagamento},
      {indicador: 'Taxas de entrega', valor: this.resumoVendas.taxaDeEntrega},
      {indicador: 'Quantidade de pedidos', valor: this.resumoVendas.qtde},
      {indicador: 'Ticket médio', valor: this.resumoVendas.ticketMedio}
    ];
  }

  private colunasVendasDiarias() {
    if(this.filtrandoPorFormaPagamento) {
      return [
        [this.rotuloColunaData, 'dia'], ['Pedidos', 'qtde'],
        ['Total em pagamentos', 'totalPagamentosComTaxa', 'moeda']
      ];
    }

    return [
      [this.rotuloColunaData, 'dia'], ['Pedidos', 'qtde'], ['Produtos', 'qtdeLinhas'],
      ['Taxa de entrega', 'totalTaxaDeEntrega', 'moeda'], ['Taxa de pagamento', 'totalTaxaFormaPagamento', 'moeda'],
      ['Total', 'totalComTaxa', 'moeda'], ['Ticket médio', 'ticketMedio', 'moeda']
    ];
  }

  private montePlanilhaRelatorio(nome: string, colunas: any[], dados: any[]) {
    const linhas: any[] = [
      {cells: [{value: 'Relatório financeiro', bold: true, fontSize: 16}]},
      {cells: [{value: `Período: ${moment(this.filtro.inicio).format('DD/MM/YYYY')} a ${moment(this.filtro.fim).format('DD/MM/YYYY')}`}]},
      {cells: [{value: `Período baseado em: ${this.rotuloBaseData}`}]},
      {cells: [{value: `Status: ${this.filtro.pagos && this.filtro.naoPagos ? 'Pagos e não pagos' : (this.filtro.pagos ? 'Pagos' : 'Não pagos')}`}]},
      {cells: [{value: `Canais: ${[this.filtro.delivery && 'Delivery', this.filtro.mesa && 'Mesa', this.filtro.balcao && 'Balcão'].filter(Boolean).join(', ') || 'Todos'}`}]},
      {cells: []},
      {cells: colunas.map((coluna: any) => ({value: coluna[0], bold: true, background: '#EAF2FF'}))}
    ];
    (dados || []).forEach((item: any) => linhas.push({cells: colunas.map((coluna: any) => ({
      value: coluna[2] === 'moeda' ? Number(item[coluna[1]] || 0) : item[coluna[1]],
      format: coluna[2] === 'moeda' ? '[$R$ -416]#,##0.00' : undefined
    }))}));
    return {name: nome.substring(0, 31), columns: colunas.map(() => ({width: 150})), rows: linhas, freezePane: {rowSplit: 7}};
  }

  private obtenhaConfiguracaoCsvAtiva() {
    const configuracoes: any = {
      loja: {dados: this.resumoVendas.lojas, colunas: [['Código', 'codigoLoja'], ['Loja', 'nomeLoja'], ['Pedidos', 'qtde'], ['Total', 'totalComTaxa']]},
      vendas: {dados: this.resumoVendas.diarias, colunas: this.colunasVendasDiarias()},
      produtos: {dados: this.resumoProdutos.produtos, colunas: [['Código', 'codigo'], ['Produto', 'nome'], ['Quantidade', 'qtde'], ['Total', 'total']]},
      vendemJuntos: {dados: this.paresVendemJuntosParaCsv, colunas: [
        ['Produto âncora', 'produtoBase'], ['Sugestão de cross-sell', 'produtoJunto'],
        ['Pedidos com o produto âncora', 'pedidosProdutoBase'], ['Pedidos juntos', 'pedidosJuntos'],
        ['Adesão histórica (%)', 'taxaJunto'], ['Frequência geral (%)', 'frequenciaGeral'], ['Força', 'forca'],
        ['Data inicial', 'dataInicial'], ['Data final', 'dataFinal']
      ]},
      combinacoesProdutos: {dados: this.resumoCombinacoes.combinacoes, colunas: [['Produto', 'produto'], ['Combinação', 'descricaoCombinacao'], ['Quantidade', 'qtde'], ['Total', 'totalAdicionais']]},
      cupons: {dados: this.resumoVendas.cupons, colunas: [['Cupom', 'codigo'], ['Quantidade', 'qtde'], ['Total', 'total'], ['Desconto', 'totalDesconto']]},
      promocoes: {dados: this.resumoVendas.promocoes, colunas: [['Promoção', 'descricao'], ['Quantidade', 'qtde'], ['Total', 'total'], ['Desconto', 'totalDesconto']]},
      formas: {dados: this.resumoVendas.formasDePagamento, colunas: [['Pagamento', 'nome'], ['Quantidade', 'qtde'], ['Total', 'total']]},
      formasEntrega: {dados: this.resumoVendas.formasDeEntrega, colunas: [['Entrega', 'nome'], ['Quantidade', 'qtde'], ['Total', 'total']]},
      garcons: {dados: this.resumoGarcons.garcons, colunas: [['Garçom', 'garcom'], ['Pedidos', 'qtde'], ['Total', 'total']]},
      operadores: {dados: this.resumoOperadores.operadores, colunas: [['Operador', 'operador'], ['Pedidos', 'qtde'], ['Total', 'total']]}
    };
    return configuracoes[this.abaPrincipalAtiva];
  }

  downloadCsvCupons() {
    let link = '/exportar/vendas/cupons/csv?';
    let filtro = this.obtenhaFiltro();

    Object.keys(filtro).forEach( key => {
      link  = String(`${link}${key}=${filtro[key]}&`) ;
    })

    window.open(link  );
  }

  downloadCsvPromocoes() {
    let link = '/exportar/vendas/promocoes/csv?';
    let filtro = this.obtenhaFiltro();

    Object.keys(filtro).forEach( key => {
      link  = String(`${link}${key}=${filtro[key]}&`) ;
    })

    window.open(link  );
  }

  downloadCsvPromocoesContatos() {
    let link = '/exportar/vendas/promocoes/contatos/csv?';
    let filtro = this.obtenhaFiltro();

    Object.keys(filtro).forEach( key => {
      link  = String(`${link}${key}=${filtro[key]}&`) ;
    })

    window.open(link  );
  }

  downloadCsvCuponsContatos(){
    let link = '/exportar/vendas/cupons/contatos/csv?';
    let filtro = this.obtenhaFiltro();

    Object.keys(filtro).forEach( key => {
      link  = String(`${link}${key}=${filtro[key]}&`) ;
    })

    window.open(link  );
  }


  sortChange($event: any) {
    this.sortCupom = $event;
    this.vendasCuponsResultSet = orderBy(process(this.resumoVendas.cupons, {}).data, this.sortCupom);
  }

  sortChangeLojas(sort: SortDescriptor[]){
    this.sortLoja = sort;
    this.vendasLojasResultSet = orderBy(process(this.resumoVendas.lojas, {}).data, this.sortLoja);
  }

  sortChangePromocoes(sort: SortDescriptor[]){
    this.sortPromocoes = sort;
    this.vendasPromocoesResultSet = orderBy(process(this.resumoVendas.promocoes, {}).data, this.sortPromocoes);
  }

  exibirPeriodoEspecifico() {
    this.periodoEspecifico = true;
  }

  exibirPeriodoMensal() {
    this.periodoEspecifico = false;
    if(!this.valorMes){
      this.valorMes = new Date();
      this.mudouValorMes(this.valorMes)
    }
  }

  public produtosMaisTaxas = (): any  => {
    let myState: any = {};

    let produtos = this.resumoProdutos.produtos;

    produtos.push({})

    myState.skip = 0;
    myState.take = produtos.length;

    const result: ExcelExportData =  {
      data: process(produtos, myState).data
    };
    return result;
  };
}
